// ============================================
// App Store (Zustand)
// 앱 전역 상태 관리
// ============================================

import { createStore } from 'zustand/vanilla';

export const useAppStore = createStore((set, get) => ({
  // ============================================
  // State
  // ============================================

  // 현재 채팅 상태 (세션 구조)
  currentRoomId: null,
  currentSessionId: null,
  currentChatId: null,       // 레거시 호환
  currentChatData: null,
  currentTurnCount: 0,

  // 현재 프로필
  currentProfile: null,

  // UI 상태
  isProcessing: false,
  currentTab: 'home',

  // ============================================
  // Actions - Chat
  // ============================================

  setCurrentRoomId: (roomId) => set({ currentRoomId: roomId }),

  setCurrentSessionId: (sessionId) => set({
    currentSessionId: sessionId,
    currentChatId: sessionId  // 레거시 호환
  }),

  setCurrentChatId: (chatId) => set({ currentChatId: chatId }),

  setCurrentChatData: (chatData) => set({ currentChatData: chatData }),

  setCurrentTurnCount: (count) => set({ currentTurnCount: count }),

  incrementTurnCount: () => set((state) => ({
    currentTurnCount: state.currentTurnCount + 1
  })),

  decrementTurnCount: () => set((state) => ({
    currentTurnCount: Math.max(0, state.currentTurnCount - 1)
  })),

  // ============================================
  // Actions - Profile
  // ============================================

  setCurrentProfile: (profile) => set({ currentProfile: profile }),

  // ============================================
  // Actions - UI
  // ============================================

  setIsProcessing: (processing) => set({ isProcessing: processing }),

  setCurrentTab: (tab) => set({ currentTab: tab }),

  // ============================================
  // Actions - Reset
  // ============================================

  resetChatState: () => set({
    currentRoomId: null,
    currentSessionId: null,
    currentChatId: null,
    currentChatData: null,
    currentTurnCount: 0
  }),

  // ============================================
  // Selectors (derived state)
  // ============================================

  getNarrativeState: () => {
    const chatData = get().currentChatData;
    return chatData?.narrativeState || null;
  },

  getLocation: () => {
    const chatData = get().currentChatData;
    return chatData?.narrativeState?.location?.current || '-';
  },

  getWorldTime: () => {
    const chatData = get().currentChatData;
    return chatData?.narrativeState?.time?.description ||
           chatData?.narrativeState?.time?.period || '-';
  }
}));

export default useAppStore;
